import { DsIcon } from '@descomplica/design-system-react';
import React from 'react';

import { Video } from '../../../classroom.vm';
import { Autoplay } from '../autoplay/autoplay';
import { CurrentLessonHeader } from '../current-lesson-header';
import { PlayerContainer } from '../player';
import { VideoProgress } from '../player/player';

interface LessonPlayerProps {
  mobileSidebarOpen: boolean;
  title: string;
  onClose: () => void;
}

interface LessonRecordedPlayerProps {
  currentVideo: Video;
  onVideoProgress: (videoProgress: VideoProgress) => void;
  handleVideoPlaying: () => Promise<void>;
  showAutoplay?: boolean;
  autoPlay?: boolean;
}

export const VideoPlayerContainer = ({
  mobileSidebarOpen,
  title,
  onClose,
  currentVideo,
  onVideoProgress,
  handleVideoPlaying,
  showAutoplay = true,
  autoPlay,
}: LessonPlayerProps & LessonRecordedPlayerProps) => (
  <div className={`current-lesson ${mobileSidebarOpen ? 'hidden' : ''}`}>
    <CurrentLessonHeader title={title} onClose={onClose} />

    <PlayerContainer
      video={currentVideo}
      onVideoProgress={onVideoProgress}
      onVideoPlaying={handleVideoPlaying}
      autoPlay={autoPlay}
    />

    {showAutoplay ? (
      <div
        className="autoPlay-lesson"
        aria-label="Habilitando essa opção, as videoaulas tocarão automaticamente. Ao final delas, você será redirecionado para a próxima tarefa da lista."
      >
        <DsIcon image="info" color="neutral-00" />
        Reproduzir vídeos automaticamente
        <Autoplay />
      </div>
    ) : null}
  </div>
);
